namespace RioERP.Carts {
    export namespace FranchiseeProductCategoryService {
        export const baseUrl = 'Carts/FranchiseeProductCategory';

        export declare function Create(request: Serenity.SaveRequest<FranchiseeProductCategoryRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<FranchiseeProductCategoryRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<FranchiseeProductCategoryRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<FranchiseeProductCategoryRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Carts/FranchiseeProductCategory/Create",
            Update = "Carts/FranchiseeProductCategory/Update",
            Delete = "Carts/FranchiseeProductCategory/Delete",
            Retrieve = "Carts/FranchiseeProductCategory/Retrieve",
            List = "Carts/FranchiseeProductCategory/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>FranchiseeProductCategoryService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
